import {
  queryOptions,
  useSuspenseQueries,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { create, keyResolver, windowScheduler } from "@yornaath/batshit";
import type { Offer } from "shared/dist/mortgage/offer.interface";
import { Api } from "@/api.config";
import { QueryKeys } from "@/LinkGen";

const batcher = create({
  fetcher: async (IDs: number[]) => Api.MortgageOffers(IDs),
  resolver: keyResolver("ID"),
  scheduler: windowScheduler(50),
});

function mortgageOfferQueryOptions(
  mortgageID: number,
  ID: number | null | undefined,
) {
  return queryOptions({
    queryKey: QueryKeys.Mortgage.Offer(mortgageID, ID),
    queryFn: () => {
      if (!ID) {
        return null;
      }

      return batcher.fetch(ID);
    },
  });
}

export function useSuspenseMortgageOffer(mortgageID: number, ID: number): Offer;
export function useSuspenseMortgageOffer(mortgageID: number, ID: null): null;
export function useSuspenseMortgageOffer(
  mortgageID: number,
  ID: undefined,
): null;
export function useSuspenseMortgageOffer(
  mortgageID: number,
  ID: number | null | undefined,
): Offer | null;

export function useSuspenseMortgageOffer(
  mortgageID: number,
  ID: number | null | undefined,
) {
  const { data } = useSuspenseQuery(mortgageOfferQueryOptions(mortgageID, ID));

  return data;
}

export function useSuspenseMortgageOfferList(
  mortgageID: number,
  offerIDs: number[],
) {
  const data = useSuspenseQueries({
    queries: offerIDs.map((ID) => mortgageOfferQueryOptions(mortgageID, ID)),
  });

  return data.map((x) => x.data as Offer);
}
